import React from "react";
import LibraryFolder from "../../components/Library/LibraryFolder";
const LibraryPage = (props)=>{
    return(
        <div>
            <LibraryFolder {...props}/>
        </div>
    );
}
export default LibraryPage;